import { Box, Button, CloseButton, Dialog, IconButton } from "@chakra-ui/react";
import { ArrowLeftIcon, ArrowRightIcon } from "@phosphor-icons/react/dist/ssr";
import React, { useState } from "react";
import ReactPlayer from "react-player";

import { normalizePhotoUrl } from "@/utilities/helpers/normalizePhotoUrl";
import { wrapBgImage } from "@/utilities/helpers/wrapBgImage";

const ModalGallery = ({ images, isOpen, onClose }) => {
    const [idx, setIdx] = useState(0);
    // Same JSON-escaped cover URL as PhotoGallery — normalized for the same
    // reason: these are CSS backgrounds today, but the escape only survives
    // because CSS unescapes `\/`.
    const currentUrl = normalizePhotoUrl(images[idx]?.url) || "";

    const handleDecrement = () => {
        if (idx > 1) setIdx(idx - 1);
        else setIdx(images.length - 1);
    };

    const handleIncrement = () => {
        if (idx < images.length - 1) setIdx(idx + 1);
        else setIdx(0);
    };

    return (
        <Dialog.Root onOpenChange={() => onClose()} size="cover" open={isOpen} preventScroll>
            <Dialog.Backdrop />
            <Dialog.Positioner>
                <Dialog.Content mb={0} bg="#0000008f">
                    <Dialog.Header />
                    <Dialog.Body display="flex" alignItems="center" justifyContent="center">
                        <Dialog.CloseTrigger asChild>
                            <CloseButton color="white" />
                        </Dialog.CloseTrigger>
                        <IconButton
                            boxShadow="md"
                            borderRadius="full"
                            size="md"
                            p={2}
                            onClick={handleDecrement}
                            bg="white"
                            variant="link"
                            minW={0}
                            _hover={{ bg: "#EFEFEF" }}
                            position="fixed"
                            left="0"
                            top="50%"
                            transform="translate(50%, -50%)"
                            color="brand.600"
                        >
                            <ArrowLeftIcon size={5} />
                        </IconButton>
                        <Box
                            w="98%"
                            h="80vh"
                            //h={zoomed ? "150vh":"75vh"}
                            bgImage={wrapBgImage(
                                currentUrl.includes("https://youtu.be")
                                    ? ""
                                    : currentUrl.includes("http")
                                      ? currentUrl
                                      : `https://media.wiggot.mx/${currentUrl}-l.jpg`
                            )}
                            bgSize="contain"
                            backgroundRepeat="no-repeat"
                            bgPos="center"
                            //cursor={zoomed ? "zoom-out" :"zoom-in"}
                            //onClick={handleZoom}
                            onClick={handleIncrement}
                        >
                            {currentUrl.includes("https://youtu.be") ? (
                                <ReactPlayer url={images[idx]} loop width="100%" height="100%" />
                            ) : (
                                <></>
                            )}
                        </Box>
                        <IconButton
                            boxShadow="md"
                            borderRadius="full"
                            size="md"
                            p={2}
                            onClick={handleIncrement}
                            bg="white"
                            variant="link"
                            minW={0}
                            _hover={{ bg: "#EFEFEF" }}
                            position="fixed"
                            right="0"
                            top="50%"
                            transform="translate(-50%, -50%)"
                            color="brand.600"
                        >
                            <ArrowRightIcon size={5} />
                        </IconButton>
                    </Dialog.Body>
                    <Dialog.Footer>
                        <Button
                            bg="#FFCD00"
                            _hover={{
                                bg: "#EDBE00",
                            }}
                            onClick={onClose}
                            px={3}
                            mr={3}
                            mb={3}
                        >
                            Cerrar
                        </Button>
                    </Dialog.Footer>
                </Dialog.Content>
            </Dialog.Positioner>
        </Dialog.Root>
    );
};

export default ModalGallery;
